<template>
  <div>
    <b-form-group label="Title">
      <b-input v-model="content.title" placeholder="e.g Awesome Hero Block" />
    </b-form-group>

    <b-form-group label="Text (optional)">
      <b-input v-model="content.text" placeholder="e.g lorem ipsum" />
    </b-form-group>

    <b-form-group label="Background image link">
      <b-input v-model="content.bg_image" placeholder="e.g https://youwish.no/images/home/background.png" />
    </b-form-group>

    <div class="mb-2">Icons</div>

    <template v-if="content.icons">
      <b-row v-for="(icon, index) in content.icons" :key="index" class="mb-3">
        <b-col>
          <b-input-group class="align-items-center">
            <b-form-select v-model="content.icons[index].type" :options="options" class="mr-3" />

            <b-form-checkbox v-model="content.icons[index].show_icon" class="mr-3">Show icon</b-form-checkbox>

            <b-form-checkbox v-model="content.icons[index].show_text" class="mr-3">Show text</b-form-checkbox>

            <template #append>
              <b-button
                variant="danger"
                @click="() => removeIcon(index)"
              >
                <strong>&times;</strong>
              </b-button>
            </template>
          </b-input-group>
        </b-col>
      </b-row>
    </template>

    <b-button variant="light" size="sm" @click="addEmptyIcon">
      Add Icon
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'PagesHeroWidget',

  props: {
    value: {
      type: Object
    },
  },

  data() {
    return {
      content: this.value,
      resolved: {
        type: Object
      },
      options: [
        { value: 'experiences', text: 'Experiences' },
        { value: 'places', text: 'Places' },
        { value: 'reviews', text: 'Reviews' },
        { value: 'customers', text: 'Customers' },
        { value: 'threeYears', text: 'Three years valid to' },
      ],
    }
  },

  methods: {
    addEmptyIcon() {
      this.content.icons.push({
        show_icon: true,
        type: '',
        show_text: true,
      })
    },

    removeIcon(index) {
      if (this.content.icons.length === 1) {
        this.content.icons = []
        return
      }

      this.content.icons.splice(index, 1)
    },
  },
}
</script>